var CATEGORY_NAVIGATION_PATH_SEPARATOR = "|";
export function buildCategoryNavigationPath(urlIds) {
    return urlIds.map(function(urlId) {
        return decodeURI(urlId);
    }).join(CATEGORY_NAVIGATION_PATH_SEPARATOR);
}
export function getUrlIdsFromNavigationPath(navigationPath) {
    return navigationPath.split(CATEGORY_NAVIGATION_PATH_SEPARATOR);
}
